<section class="wifi-onboard-bookref" id="activate-pnr">
    <div class="form-wrapper mob-view">
        <div class="req-info login">
            <span>{{'reqInfo' | translate}}</span>
        </div>

        <form [formGroup]="pnrForm" class="pnr-input-form" role="form" name="wifi-onboard-connect-bookRef" autocomplete="off" novalidate="" form-autofill-fix="">

            <div class="input-set large-6 medium-6 small-12 col activate-input firstname-input">
                <label id="firstNameLabel" [ngClass]="{'top-set': fnameTopSet}" for="firstName">{{'wifiLogin.textBox.firstName' | translate}}*</label>
                <input formControlName='firstname' id="firstName" name="" type="text" value="" class="no-radius-hover" [attr.aria-label]="('wifiLogin.textBox.firstName' | translate)" aria-invalid="false" tabindex="0" role="textbox" (focus)="onActiveFname()" (blur)="onBlurFname()"
                    required>
                <div class="tool-tip bottom-left small error onboard-tool-tip" *ngIf="firstname.invalid && showFnameErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                        <div *ngIf="firstname.errors.required">{{'message.7011036' | translate}}</div>
                        <div *ngIf="firstname.errors.pattern || firstname.errors.minlength">{{'message.7011037' | translate}}</div>
                        <div *ngIf="firstname.errors.maxlength && !firstname.errors.pattern">
                            {{'message.7011038' | translate}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-set large-6 medium-6 small-12 col activate-input lastname-input">
                <label id="lastNameLabel" [ngClass]="{'top-set': lnameTopSet}" for="lastName">{{'wifiLogin.textBox.lastName' | translate}}*</label>
                <input formControlName='secondname' id="lastName" name="" type="text" value="" class="no-radius-hover" [attr.aria-label]="('wifiLogin.textBox.lastName' | translate)" aria-invalid="false" tabindex="0" role="textbox" (focus)="onActiveLname()" (blur)="onBlurLname()"
                    required>
                <div class="tool-tip bottom-left small error onboard-tool-tip" *ngIf="secondname.invalid && showLnameErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                        <div *ngIf="secondname.errors.required">{{'message.7011033' | translate}}</div>
                        <div *ngIf="secondname.errors.pattern || secondname.errors.minlength">{{'message.7011034' | translate}}
                        </div>
                        <div *ngIf="secondname.errors.maxlength && !secondname.errors.pattern">
                            {{'message.7011035' | translate}}
                        </div>
                    </div>
                </div>
            </div>


            <div *ngIf="!isCharter" class="input-set large-6 medium-6 small-12 col mar activate-input">
                <label id="bookRefLabel" [ngClass]="{'top-set': pnrTopSet}" for="bookRef">{{'wifiLogin.textBox.bookingReference' | translate}}*</label>
                <input formControlName='pnr' id="bookRef" name="" type="text" value="" (focus)="onActivePnr()" aria-invalid="false" [attr.aria-label]="('wifiLogin.textBox.bookingReference' | translate)" tabindex="0" role="textbox" (blur)="onBlurPnr()" required />
                <button type="button" id="infofree" class="infofree" tabindex="0" (focus)="onActivePnrInfoIcon()" (blur)="onBlurPnrInfoIcon()" (click)="onActivePnrInfoIcon()" (clickOutside)="onBlurPnrInfoIcon()" [attr.aria-label]="('pnr.toolTip' | translate)" name="loginoption">
          <svg class="info-circle-icon" role="presentation">
            <use xlink:href="#cl--info-circle" href="#cl--info-circle"></use>
          </svg>
        </button>


                <div class="tool-tip bottom-right small" *ngIf="displayPNRInfo">
                    <div class="tool-tip-inner info-tool-tip">{{'pnr.toolTip' | translate}}</div>
                </div>
                <div class="tool-tip bottom-left small error onboard-tool-tip" *ngIf="pnr.invalid && showPnrErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                        <div *ngIf="pnr.errors.required">{{'message.7011039' | translate}}</div>
                        <div *ngIf="pnr.errors.pattern || pnr.errors.minlength">{{'message.7011040' | translate}}</div>
                        <div *ngIf="pnr.errors.maxlength && !pnr.errors.pattern">
                            {{'message.7011041' | translate}}
                        </div>
                        <div *ngIf="(pnr.value.toUpperCase() === this.flightResponseDetail.flightNumber.toUpperCase()) && !pnr.errors.pattern">
                            {{'message.7011062' | translate}}
                        </div>
                        <div *ngIf="pnr.hasError('pnrHasZero') && !pnr.errors.pattern && (pnr.value.toUpperCase() !== this.flightResponseDetail.flightNumber.toUpperCase())">
                            {{'message.7011061' | translate}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- for charter flight flow  start -->
            <div *ngIf="isCharter" class="input-set large-6 medium-6 small-12 col activate-input email-input">
                <label id="emailLabel" [ngClass]="{'top-set': emailTopSet}" for="email">{{'email' | translate}}*</label>
                <input formControlName='email' id="email" name="" type="text" value="" class="no-radius-hover" [attr.aria-label]="('email' | translate)" aria-invalid="false" tabindex="0" role="textbox" (focus)="onActiveEmail()" (blur)="onBlurEmail()" required>
                <div class="tool-tip bottom-left small error onboard-tool-tip" *ngIf="email.invalid && showEmailErrorMsg" role="alert">
                    <div class="tool-tip-inner">
                        <div *ngIf="email.errors.required">{{'message.7011059' | translate}}</div>
                        <div *ngIf="email.errors.pattern">{{'message.7011060' | translate}}</div>
                    </div>
                </div>
            </div>
            <!-- eod of charter -->

            <div class="clear"></div>
            <fieldset class="wifi-checkboxs" *ngIf="showTermsCondition">
                <legend class="hideElement"></legend>
                <div class="checkbox-wrap sasTermACondition">
                    <div>
                        <input formControlName='sastandc' type="checkbox" id="sasTnCPnr" (click)="checkSasTnC()" name="sastandc" value="false" [attr.aria-label]="('wifiLogin.label.sasTnC' | translate) +' '+ ('wifiLogin.sasTnC' | translate)" aria-required="false" aria-invalid="false"
                            role="checkbox" tabindex="0" />
                        <label for="sasTnCPnr" class="tnc-text">
              <span class="icon-ok"></span>
              {{'wifiLogin.label.sasTnC' | translate}}
              <a id="sasTermACondition" href="javascript:void(0)" (click)="openSasTnC()" tabindex="0"
                (keydown.enter)="openSasTnC()">{{'wifiLogin.sasTnC' | translate}}</a>
            </label>
                        <div class="tool-tip bottom-left small error onboard-tool-tip" *ngIf="sastandc.invalid && showSastandcErrorMsg" role="alert">
                            <div class="tool-tip-inner">
                                <div *ngIf="sastandc.errors.required">{{'wifiLogin.loggedInCustomer' | translate}}</div>

                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div id="onboard-connect-btn" class="activate-connect-button" [ngClass]="{'buy-connect':!showTermsCondition}">
                <button type="submit" tabindex="0" id="connect-btn" (keydown.Tab)="tabFromActivateButton($event)" (click)="pnrFormSubmit()" class="btn onboard-connect-button primary" [ngClass]="{'onboard-buy-button':!showTermsCondition}" role="button" data-modal-open="wifi-onboard-switch">
          {{'wifiLogin.connect' | translate}}
        </button>
            </div>
        </form>
    </div>
</section>

<app-terms-and-conditions *ngIf="showSasTnC" [showSasTnC]="showSasTnC" [sasTnC]="sasTnC" (closeSasTnCEvent)="closeSasTnCEvent()"></app-terms-and-conditions>